/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi from '../api/BaseApi';
import type {SidenavApi as Contract, LeftNavConfig, NavConfig} from '@adobe/exc-app/sidenav';
import {Events} from '@exc/shared';

export class SidenavApi extends BaseApi implements Contract {
  protected apiEvents = ['shellSideNavCollapsed'];
  protected keyPrefix = 'sidenav';

  public get config(): NavConfig | undefined {
    return this.configManager.get('sidenav/config');
  }

  public set config(value: NavConfig | undefined) {
    this.configManager.set({'sidenav/config': value});
  }

  public get visible(): boolean | undefined {
    return this.configManager.get('sidenav/visible');
  }

  public set visible(value: boolean | undefined) {
    this.configManager.set({'sidenav/visible': value});
  }

  public get collapsed(): boolean | undefined {
    return this.configManager.get('sidenav/collapsed');
  }

  public set collapsed(value: boolean | undefined) {
    this.configManager.set({'sidenav/collapsed': value});
  }

  public useLeftNavButton(config: LeftNavConfig) {
    this.messenger.send(Events.CUSTOM_LEFT_NAV_CLICK, config.closeOnSelection);
    this.messenger.setCallback(Events.CUSTOM_LEFT_NAV_CLICK, config.callback);
  }
}
